/**
 * Context for CollectionGesture Consumer and Provider
 */

import { createContext } from 'preact';

/**
 * This context (with value 'embedded') should be created by component that has a drop down and the drop down
 * contains a Collection component that uses grid role (ListView and Table).
 * The behavior of the Collection component will alter when it is inside of a drop down.  Specifically,
 * enter key will update the selection, and spacebar key will fire ItemAction event.
 */
export const CollectionGestureContext = createContext<'default' | 'embedded' | undefined>(
  'default'
);
